import { ToastConfig } from 'react-native-toast-message';

import { ToastComponent } from './ToastComponent';

export const toastConfig: ToastConfig = {
	success: ToastComponent,
	info: ToastComponent,
	warning: ToastComponent,
	error: ToastComponent,
};
